//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    methods: {
        goComments (e) {
            this.$emit('goComments', e)
        },
        openMap () {
            this.$emit('openMap')
        }
    },
    props: {
        house: {
            type: Object,
            default: () => {
                return {}
            }
        }
    }
}
